import LyfeTypography, { LyfeTypographyTypes } from "libs/react-common/src/Typography/Typography";
import { ReactNode, useEffect, useRef, useState } from "react";
import LyfeTooltip from "./LyfeTooltip";
import { TypographyProps } from "@material-ui/core";

interface OverflowTooltipTypographyProps extends TypographyProps, LyfeTypographyTypes {
	renderTooltipText?: () => void;
	children: ReactNode;
}

export default function OverflowTooltipTypography({ renderTooltipText, children, ...props }: OverflowTooltipTypographyProps) {
	const textRef = useRef<HTMLSpanElement | null>(null);
	const [isOverflowing, setIsOverflowing] = useState(false);

	const checkOverflow = () => {
		const el = textRef.current;
		if (el) {
			setIsOverflowing(el.scrollWidth > el.clientWidth);
		}
	};

	useEffect(() => {
		checkOverflow();
		window.addEventListener("resize", checkOverflow);
		return () => window.removeEventListener("resize", checkOverflow);
	}, [children]);

	const typography = (
		<LyfeTypography ref={textRef} noWrap {...{ variant: "body2", type: "regular", ...props }}>
			{children}
		</LyfeTypography>
	);

	return isOverflowing ? <LyfeTooltip title={renderTooltipText?.() ?? String(children)}>{typography}</LyfeTooltip> : typography;
}
